import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';
import Typography from 'src/components/Text/Text';
import { themes } from 'src/theme/theme';
import { RootState } from 'src/store/store';
import { formatDate, toDate } from 'src/helpers/dateHelper';

const SidebarAppInfo: React.FC = () => {
  const company = useSelector((state: RootState) => state.company.company);
  const application = useSelector((state: RootState) => state.application.application);
  const filledTabsIndex = useSelector((state: RootState) => state.UI.filledTabsIndex);

  const totalSteps = 6;
  const progressPercent = Math.round((filledTabsIndex / totalSteps) * 100);

  if (!company || company.id <= 0) return null;

  const effectiveDate = application?.effectiveDateRequested
    ? application.effectiveDateRequested instanceof Date
      ? application.effectiveDateRequested
      : toDate(String(application.effectiveDateRequested))
    : null;

  const infoRows: { label: string; value: string | number | null }[] = [
    { label: 'DOT', value: company.dotNumber },
    { label: 'MC', value: company.mcNumber },
    { label: 'Fleet Size', value: company.fleetSize || null },
    { label: 'Power Units', value: company.totalPowerUnits || null },
    { label: 'CDL Drivers', value: company.cdlEmployedDrivers || null },
    { label: 'Owner', value: application?.ownerName || null },
    {
      label: 'Eff. Date',
      value: effectiveDate ? formatDate(effectiveDate, 'MM/DD/YYYY') : null,
    },
  ];

  return (
    <View style={styles.container}>
      <Typography variant="caption1Medium" style={styles.header}>
        APPLICATION INFO
      </Typography>

      {infoRows.map(
        (row) =>
          row.value != null && (
            <View key={row.label} style={styles.row}>
              <Typography variant="caption2" style={styles.label}>
                {row.label}
              </Typography>
              <Typography variant="caption1Regular" style={styles.value} numberOfLines={1}>
                {row.value}
              </Typography>
            </View>
          ),
      )}

      {/* Progress */}
      <View style={styles.progressContainer}>
        <View style={styles.progressBarOuter}>
          <View style={[styles.progressBarInner, { width: `${progressPercent}%` }]} />
        </View>
        <Typography variant="caption2" style={styles.progressText}>
          {progressPercent}% complete
        </Typography>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: themes.light.gray[7],
  },
  header: {
    color: themes.light.gray[5],
    marginBottom: 8,
    letterSpacing: 0.5,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 3,
  },
  label: {
    color: themes.light.gray[5],
  },
  value: {
    color: themes.light.gray_blue[1],
    flex: 1,
    textAlign: 'right',
    marginLeft: 8,
  },
  progressContainer: {
    marginTop: 8,
  },
  progressBarOuter: {
    height: 5,
    backgroundColor: themes.light.gray[7],
    borderRadius: 3,
    overflow: 'hidden',
    marginBottom: 4,
  },
  progressBarInner: {
    height: '100%',
    backgroundColor: themes.light.brand_blue[3],
    borderRadius: 3,
  },
  progressText: {
    color: themes.light.gray[5],
  },
});

export default SidebarAppInfo;
